import { getUIContext, apiAdn } from "./common";

export function createTraduction(props: { sjmoCode: string; resourceKey: string; title: string }) {
  const params = getUIContext({ sjmoCode: props.sjmoCode });
  return apiAdn.post(`/admin/common/traduction?${params}`, props);
}
